import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContentSectionCard = ({ section, onEdit }) => {
  const getCompletionColor = (percentage) => {
    if (percentage >= 80) return 'text-success bg-success/10';
    if (percentage >= 50) return 'text-warning bg-warning/10';
    return 'text-error bg-error/10';
  };

  const getSectionIcon = (name) => {
    switch (name) {
      case 'Profile': return 'User';
      case 'Promotion': return 'Megaphone';
      case 'About': return 'FileText';
      case 'Calendar': return 'Calendar';
      case 'Work': return 'Briefcase';
      case 'Shop': return 'ShoppingBag';
      default: return 'File';
    }
  };

  const renderSectionContent = () => {
    switch (section?.name) {
      case 'Profile':
        return (
          <div className="space-y-2">
            <div className="flex items-center justify-between text-sm">
              <span className="text-text-secondary">Basic Info:</span>
              <span className={`px-2 py-1 rounded text-xs ${section?.basicInfo ? 'bg-success/10 text-success' : 'bg-error/10 text-error'}`}>
                {section?.basicInfo ? 'Complete' : 'Incomplete'}
              </span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <span className="text-text-secondary">Social Links:</span>
              <span className="text-text-primary">{section?.socialLinksCount}/6 added</span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <span className="text-text-secondary">Contact Info:</span>
              <span className={`px-2 py-1 rounded text-xs ${section?.contactComplete ? 'bg-success/10 text-success' : 'bg-warning/10 text-warning'}`}>
                {section?.contactComplete ? 'Complete' : 'Partial'}
              </span>
            </div>
          </div>
        );
      
      case 'Calendar':
        return (
          <div className="space-y-2">
            <div className="flex items-center justify-between text-sm">
              <span className="text-text-secondary">Total Events:</span>
              <span className="text-text-primary font-medium">{section?.totalEvents}</span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <span className="text-text-secondary">Upcoming:</span>
              <span className="text-accent font-medium">{section?.upcomingEvents}</span>
            </div>
            <div className="text-sm text-text-secondary">
              Latest: {section?.latestEvent}
            </div>
          </div>
        );
      
      case 'Work':
        return (
          <div className="space-y-2">
            <div className="flex items-center justify-between text-sm">
              <span className="text-text-secondary">Total Works:</span>
              <span className="text-text-primary font-medium">{section?.totalWorks}</span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <span className="text-text-secondary">Featured:</span>
              <span className="text-accent font-medium">{section?.featuredWorks}</span>
            </div>
            <div className="text-sm text-text-secondary">
              Last Updated: {section?.lastUpdated}
            </div>
          </div>
        );
      
      default:
        return (
          <div className="space-y-2">
            <div className="text-sm text-text-secondary">
              {section?.description}
            </div>
            {section?.lastModified && (
              <div className="text-xs text-text-secondary">
                Modified: {section?.lastModified}
              </div>
            )}
          </div>
        );
    }
  };

  return (
    <div className="bg-surface border border-border rounded-lg p-4 elevation-1 hover:elevation-2 transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
            <Icon name={getSectionIcon(section?.name)} size={20} className="text-accent" />
          </div>
          <div>
            <h3 className="font-semibold text-text-primary">{section?.name}</h3>
            <div className="flex items-center space-x-2 mt-1">
              <div className={`px-2 py-1 rounded-full text-xs font-medium ${getCompletionColor(section?.completion)}`}>
                {section?.completion}% Complete
              </div>
              {section?.hasErrors && (
                <div className="flex items-center space-x-1 text-error">
                  <Icon name="AlertTriangle" size={12} />
                  <span className="text-xs">Issues</span>
                </div>
              )}
            </div>
          </div>
        </div>
        
        <Button
          variant="outline"
          size="sm"
          iconName="Edit"
          iconPosition="left"
          onClick={() => onEdit(section?.name)}
        >
          Edit
        </Button>
      </div>
      <div className="border-t border-border pt-4">
        {renderSectionContent()}
      </div>
      {section?.completion < 100 && (
        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex items-center space-x-2 text-sm text-warning">
            <Icon name="AlertCircle" size={14} />
            <span>Missing required fields</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContentSectionCard;